// src/app/services/global-loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderService {
  private _isLoading = new BehaviorSubject<boolean>(false);
  public readonly isLoading$: Observable<boolean> = this._isLoading.asObservable();

  constructor() { }

  showLoader() {
    this._isLoading.next(true);
    // console.log('Global loader shown.');
  }

  hideLoader() {
    this._isLoading.next(false);
    // console.log('Global loader hidden.');
  }
}